var _rect, _line, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#1f396c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 20,
    height: 16,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 8,
    x2: 22,
    y2: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 0.5,
    fill: "#1f396c",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6,
    r: 0.5,
    fill: "#1f396c",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12c-1 0-1 2-2 2 1 0 1 2 2 2",
    stroke: "#2f6fed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12c1 0 1 2 2 2-1 0-1 2-2 2",
    stroke: "#2f6fed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDevelopment);
export default __webpack_public_path__ + "static/media/apiDevelopment.c4da224f8034d49f838c6fbd6fa33e9d.svg";
export { ForwardRef as ReactComponent };